import React from 'react';
import { FiClock, FiMessageSquare, FiShield, FiUsers } from 'react-icons/fi';

const items = [
  {
    icon: <FiClock className="h-5 w-5" />,
    title: '24/7 availability',
    text: 'Request support any time through our service desk.',
  },
  {
    icon: <FiShield className="h-5 w-5" />,
    title: 'Secure handling',
    text: 'Your request details are processed through a protected flow.',
  },
  {
    icon: <FiUsers className="h-5 w-5" />,
    title: 'Partner-trained agents',
    text: 'Experienced teams handle subscription and billing questions.',
  },
  {
    icon: <FiMessageSquare className="h-5 w-5" />,
    title: 'Clear communication',
    text: 'Straightforward answers, quick follow-up, and guided next steps.',
  },
];

type TrustBarProps = {
  layout?: 'grid' | 'stack';
  className?: string;
};

export default function TrustBar({ layout = 'grid', className = '' }: TrustBarProps) {
  const containerClassName =
    layout === 'stack'
      ? 'grid gap-4 rounded-[32px] border border-[var(--line-soft)] bg-white/70 p-5 shadow-[0_24px_60px_-42px_rgba(8,31,53,0.35)] backdrop-blur-xl sm:p-6'
      : 'grid gap-4 rounded-[32px] border border-[var(--line-soft)] bg-white/70 p-5 shadow-[0_24px_60px_-42px_rgba(8,31,53,0.35)] backdrop-blur-xl sm:grid-cols-2 sm:p-6 md:grid-cols-4';

  return (
    <section className={`px-4 py-8 sm:px-6 lg:px-8 lg:py-10 ${className}`}>
      <div className="mx-auto max-w-7xl">
        <div className={containerClassName}>
          {items.map(item => (
            <div key={item.title} className="flex flex-col items-start gap-3 rounded-[24px] border border-[var(--line-soft)] bg-[linear-gradient(180deg,rgba(255,255,255,0.98),rgba(244,247,251,0.92))] p-5">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[var(--brand-accent)] text-white shadow-[0_16px_30px_-20px_rgba(31,111,120,0.95)]">
                {item.icon}
              </div>
              <h3 className="text-sm font-semibold text-[var(--brand-ink)]">{item.title}</h3>
              <p className="mt-1 text-sm text-[var(--text-muted)]">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
